<template>
    <v-container class="hide-scrollbar">
        <div class="wrapper">
            <v-overlay
                :model-value="loading"
                class="align-center justify-center"
            >
                <v-progress-circular
                    color="blue-lighten-3"
                    indeterminate
                    :size="120"
                >
                    <v-img
                        src="/images/d3_connect.png"
                        v-if="loading"
                        :size="10"
                        class="loading-spinner"
                        :style="{
                            marginLeft: '9px',
                        }"
                        indeterminate
                    ></v-img>
                </v-progress-circular>
            </v-overlay>
            <v-row>
                <!-- <v-col cols="2">
                    <div class="progress-text" style="font-size: 4em">
                        {{ currentTime }}
                    </div>
                </v-col> -->
                <v-col>
                    <div
                        v-for="(item, index) in finalArray"
                        :key="index"
                        class="content"
                    >
                        <v-row no-gutters>
                            <v-col cols="2">
                                <div class="project">
                                    {{ item.Name }}
                                </div>
                            </v-col>
                            <template
                                v-for="(num, i) in item.NumJobs"
                                :key="i"
                            >
                                <v-col>
                                    <!---:striped="applyStriped(item, num)"-->
                                    <v-progress-linear
                                        rounded
                                        rounded-bar
                                        :color="
                                            getProgressBarColor(item, num)
                                        "
                                        height="75"
                                        :model-value="
                                            getProgressValue(item, num)
                                        "
                                    >
                                        <template
                                            v-if="applyStriped(item, num)"
                                        >
                                            <v-icon
                                                style="margin-left: 10px"
                                                color="black"
                                                icon="mdi:mdi-account-clock"
                                                size="x-large"
                                            ></v-icon>
                                        </template>
                                        <v-row no-gutters>
                                            <v-col cols="12">
                                                <div class="progress-text">
                                                    {{
                                                        getProgressValue(
                                                            item,
                                                            num
                                                        )
                                                    }}%
                                                </div>
                                            </v-col>
                                            <v-col cols="12">
                                                <div class="progress-text">
                                                    {{
                                                        getOperation(
                                                            item,
                                                            num
                                                        )
                                                    }}
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-progress-linear>
                                </v-col>
                            </template>
                        </v-row>
                        <v-row no-gutters class="mb-3">
                            <v-col cols="2">
                                <div class="text-center">
                                    {{ item.Description }}
                                </div>
                            </v-col>
                            <v-col>
                                <v-progress-linear
                                    rounded
                                    rounded-bar
                                    color="green"
                                    height="20"
                                    :model-value="item.TotalProgress"
                                >
                                    <div
                                        class="progress-text"
                                        style="font-size: 1em"
                                    >
                                        {{ item.TotalProgress }}%
                                    </div>
                                </v-progress-linear>
                            </v-col>
                        </v-row>
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-container>
    <div v-if="rotateScreen">
        <CNCPunch
            :building="building"
            :department="department"
            :rotateScreens="true"
        />
    </div>
</template>

<script>
import axios from "axios";
import { defineAsyncComponent } from "vue";
const GuestLayout = defineAsyncComponent(() =>
    import("../../../Layouts/GuestLayout.vue")
);
const CNCPunch = defineAsyncComponent(() =>
    import("../../../components/ITDepartment/TV/CNCPunch.vue")
);

export default {
    layout: [GuestLayout],
    components: { CNCPunch },
    name: "TVScreen",
    data() {
        return {
            department: this.getDepartment(),
            building: this.getBuilding(),
            jobNumbers: [],
            jobDetails: [],
            finalArray: [],
            globalArray: [],
            deptArray: [],
            jobTypes: [
                // CNC jobs
                {
                    type: "CNC",
                    progressKey: "CNCProgress",
                    activityKey: "CNCActivity",
                },
                {
                    type: "LAS",
                    progressKey: "LASProgress",
                    activityKey: "LASActivity",
                },
                {
                    type: "TSAW",
                    progressKey: "TSAWProgress",
                    activityKey: "TSAWActivity",
                },
                {
                    type: "BMQ",
                    progressKey: "BMQProgress",
                    activityKey: "BMQActivity",
                },
                {
                    type: "BUFF",
                    progressKey: "BUFFProgress",
                    activityKey: "BUFFActivity",
                },
                // VACF jobs
                {
                    type: "VACF",
                    progressKey: "VACFProgress",
                    activityKey: "VACFActivity",
                },
                // SIL jobs
                {
                    type: "SIL",
                    progressKey: "SILProgress",
                    activityKey: "SILActivity",
                },
                {
                    type: "DIGT",
                    progressKey: "DIGTProgress",
                    activityKey: "DIGTActivity",
                },
                {
                    type: "HOT",
                    progressKey: "HOTProgress",
                    activityKey: "HOTActivity",
                },
                {
                    type: "PAD",
                    progressKey: "PADProgress",
                    activityKey: "PADActivity",
                },
                // ASM jobs
                {
                    type: "ASM",
                    progressKey: "ASMProgress",
                    activityKey: "ASMActivity",
                },
                {
                    type: "ANNEAL",
                    progressKey: "ANNEALProgress",
                    activityKey: "ANNEALActivity",
                },
                {
                    type: "HBD",
                    progressKey: "HBDProgress",
                    activityKey: "HBDActivity",
                },
                {
                    type: "HFORM",
                    progressKey: "HFORMProgress",
                    activityKey: "HFORMActivity",
                },
                {
                    type: "PACK",
                    progressKey: "PACKProgress",
                    activityKey: "PACKActivity",
                },
                {
                    type: "POLY",
                    progressKey: "POLYProgress",
                    activityKey: "POLYActivity",
                },
                {
                    type: "QC",
                    progressKey: "QCProgress",
                    activityKey: "QCActivity",
                },
                {
                    type: "SOSE",
                    progressKey: "SOSEProgress",
                    activityKey: "SOSEActivity",
                },
            ],
            currentTime: "",
            globalMode: true,
            loading: false,
            rotateScreen: false,
        };
    },
    computed: {
        getProgressValue() {
            let operationToProgressKey = {};
            this.jobTypes.forEach((jobType) => {
                operationToProgressKey[jobType.type] = jobType.progressKey;
            });

            return function (item, num) {
                let operation = this.getOperation(item, num);
                let progressKey = operationToProgressKey[operation] || 0;

                return item[progressKey] || 0;
            };
        },
        applyStriped() {
            let operationToActivityKey = {};
            this.jobTypes.forEach((jobType) => {
                operationToActivityKey[jobType.type] = jobType.activityKey;
            });

            return function (item, num) {
                let operation = this.getOperation(item, num);
                let activityKey = operationToActivityKey[operation];

                return item[activityKey] > 0;
            };
        },
    },
    async mounted() {
        if (this.department === "ASM") {
            await this.getGlobalProjects();
        }
        await this.getDeptProjects();
        // Refresh data every 4 hours
        setInterval(() => {
            if (this.department === "ASM") {
                this.getGlobalProjects();
            }
             this.getDeptProjects();
        }, 4 * 60 * 60 * 1000);

        // this.updateClock();

        setInterval(() => {
            this.rotateItems();
        }, 8000);

        if (this.department === "ASM") {
            this.startPageRotation();
        }
    },
    // beforeDestroy() {
    //     clearInterval(this.clockInterval);
    // },
    methods: {
        getDepartment() {
            let path = window.location.pathname;
            let lastSlashIndex = path.lastIndexOf("/");
            let dept = path.substring(lastSlashIndex + 1, path.length - 2);

            return dept;
        },
        getBuilding() {
            let path = window.location.pathname;
            let bldg = path.substring(path.length - 2);

            return bldg;
        },
        async getDeptProjects() {
            this.loading = true;
            this.deptArray = [];
            try {
                await axios
                    .get(
                        route("legacy-api.TV-DepartmentProjects", {
                            Building: this.building,
                            Department: this.department,
                        })
                    )
                    .then((res) => {
                        this.processProjectsDept(res.data);
                    });
            } catch (err) {
                console.log(err);
            }
            this.loading = false;
        },
        async getGlobalProjects() {
            this.loading = true;
            let arr = []
            // try {
            //     await axios
            //         .get(
            //             route("legacy-api.TV-RecentlyActiveProjects", {
            //                 Building: this.building,
            //             })
            //         )
            //         .then((res) => {
            //             arr =  res.data;
            //         });
            // } catch (err) {
            //     console.log(err);
            // }
            await this.processProjectsGlobal(arr)
            this.loading = false;
        },
        async processProjectsDept(data) {
            this.jobNumbers = Object.keys(data);
            this.jobDetails = Object.values(data);

            for (let i = 0; i < this.jobNumbers.length; i++) {
                let jobData = {
                    Name: this.jobNumbers[i],
                    Description: this.jobDetails[i].Description,
                    TotalProgress: Math.floor(
                        (this.jobDetails[i].Overall.QtyMade /
                            this.jobDetails[i].Overall.RunQty) *
                        100
                    ),
                    NumJobs: 0,
                };

                let jobTypes = this.jobTypes;

                for (let jobType of jobTypes) {
                    if (
                        typeof this.jobDetails[i][jobType.type] !== "undefined"
                    ) {
                        jobData[jobType.progressKey] = Math.floor(
                            (this.jobDetails[i][jobType.type].QtyMade /
                                this.jobDetails[i][jobType.type].RunQty) *
                            100
                        );
                        jobData[jobType.activityKey] =
                            this.jobDetails[i][jobType.type].Active;
                        jobData.NumJobs++;
                    }
                }
                this.deptArray.push(jobData);
            }
            this.showProjects();
        },
        async processProjectsGlobal(data) {
            this.jobNumbers = Object.keys(data);
            this.jobDetails = Object.values(data);

            for (let i = 0; i < this.jobNumbers.length; i++) {
                let jobData = {
                    Name: this.jobNumbers[i],
                    Description: this.jobDetails[i].Description,
                    TotalProgress: Math.floor(
                        (this.jobDetails[i].Overall.QtyMade /
                            this.jobDetails[i].Overall.RunQty) *
                        100
                    ),
                    NumJobs: 0,
                };

                let jobTypes = this.jobTypes;

                for (let jobType of jobTypes) {
                    if (
                        typeof this.jobDetails[i][jobType.type] !== "undefined"
                    ) {
                        jobData[jobType.progressKey] = Math.floor(
                            (this.jobDetails[i][jobType.type].QtyMade /
                                this.jobDetails[i][jobType.type].RunQty) *
                            100
                        );
                        jobData[jobType.activityKey] =
                            this.jobDetails[i][jobType.type].Active;
                        jobData.NumJobs++;
                    }
                }
                this.globalArray.push(jobData);
            }
            this.showProjects();
        },
        showProjects() {
            if (this.department === "ASM") {
                if (this.globalMode) {
                    this.finalArray = [];
                    this.finalArray = this.globalArray;
                } else {
                    this.finalArray = [];
                    this.finalArray = this.deptArray;
                }
                this.globalMode = !this.globalMode;

                setTimeout(this.showProjects, 240000);
            } else {
                this.finalArray = [];
                this.finalArray = this.deptArray;
            }
        },
        getOperation(item, num) {
            let jobTypes = this.jobTypes;

            let filteredJobTypes = jobTypes.filter(
                (jobType) => typeof item[jobType.progressKey] !== "undefined"
            );

            if (filteredJobTypes.length > 0) {
                let effectiveIndex = (num - 1) % filteredJobTypes.length;
                return filteredJobTypes[effectiveIndex].type;
            }

            return "ERROR";
        },
        getProgressBarColor(item, num) {
            let operation = this.getOperation(item, num);
            switch (operation) {
                // CNC
                case "CNC":
                    return "#deb887";
                case "LAS":
                    return "#00bfff";
                case "TSAW":
                    return "#7cfc00";
                case "BMQ":
                    return "#f0e68c";
                case "BUFF":
                    return "#FF69B4";
                // VACF
                case "VACF":
                    return "purple";
                // SIL
                case "SIL":
                    return "teal";
                case "DIGT":
                    return "orange";
                case "HOT":
                    return "white";
                case "PAD":
                    return "black";
                // ASM
                case "ASM":
                    return "red";
                case "ANNEAL":
                    return "black";
                case "HBD":
                    return "yellow";
                case "HFORM":
                    return "black";
                case "PACK":
                    return "pink";
                case "POLY":
                    return "black";
                case "QC":
                    return "black";
                case "SOSE":
                    return "black";
                default:
                    return "white";
            }
        },
        rotateItems() {
            let wrapper = document.querySelector(".wrapper");
            let hasOverflow = wrapper.scrollHeight > wrapper.clientHeight;

            if (hasOverflow) {
                let firstItems = this.finalArray.splice(0, 2);
                this.finalArray.push(...firstItems);
            }
        },
        updateClock() {
            this.clockInterval = setInterval(() => {
                let now = new Date();
                let hours = now.getHours() % 12 || 12;
                let minutes = now.getMinutes().toString().padStart(2, "0");
                let amPm = now.getHours() < 12 ? "AM" : "PM";
                this.currentTime = `${hours}:${minutes} ${amPm}`;
            }, 1000);
        },
        toggleAnimation() {
            this.isPaused = !this.isPaused;
        },
        startPageRotation() {
            setInterval(() => {
                this.rotateScreen = !this.rotateScreen;
            }, 6 * 60 * 1000); // 6 minutes in milliseconds
        },
    },
};
</script>

<style scoped>
/* width */
:deep(::-webkit-scrollbar) {
    display: none !important;
}

.project {
    text-align: center;
    font-size: 2em;
    margin-top: 20px;
}

.project-detail {
    text-align: center;
}

.content {
    background-color: black;
    color: white;
    margin-bottom: 10px;
    border-radius: 4px;
    min-height: 102px; /* Set a minimum height for each row */
}

.wrapper {
    background-color: black;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    padding: 0;
    padding-top: 75px;
    padding-left: 15px;
    padding-right: 15px;
    overflow-y: hidden;
}

.wrapper::-webkit-scrollbar {
    display: none;
}

.progress-text {
    font-weight: bold;
    color: white;
    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
    1px 1px 0 #000;
    text-align: center;
    font-size: 1.5em;
}
</style>
